import { Link } from 'react-router-dom';

const PageLinks = () => {
  return (
    <div className="p-4">
      <h1 className="text-3xl font-bold mb-6">All Site Links</h1>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">General Pages</h2>
        <ul className="list-disc list-inside space-y-2">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/publications">Publications</Link></li>
          <li><Link to="/faqs">FAQs</Link></li>
          <li><Link to="/services">Services</Link></li>
          <li><Link to="/about-us">About Us</Link></li>
          <li><Link to="/contact-us">Contact Us</Link></li>
          <li><Link to="/unauthorized">Unauthorized Page</Link></li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">Regulatory Services</h2>
        <ul className="list-disc list-inside space-y-2">
          <li><Link to="/regulatory-services/strategic-regulatory-planning">Strategic Regulatory Planning</Link></li>
          <li><Link to="/regulatory-services/comprehensive-ectd-spl">Comprehensive eCTD & SPL</Link></li>
          <li><Link to="/regulatory-services/publishing-services">Publishing Services</Link></li>
          <li><Link to="/regulatory-services/global-drug-master-file-dmf">Global Drug Master File (DMF)</Link></li>
          <li><Link to="/regulatory-services/classification">Classification</Link></li>
          <li><Link to="/regulatory-services/dossier-management">Dossier Management</Link></li>
          <li><Link to="/regulatory-services/regulatory-representation-services">Regulatory Representation Services</Link></li>
          <li><Link to="/regulatory-services/regulatory-support-services">Regulatory Support Services</Link></li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">GMP Audits & Compliance</h2>
        <ul className="list-disc list-inside space-y-2">
          <li><Link to="/gmp-audits-and-compliance/gmp-audits-compliance-and-training-services">GMP Audits, Compliance & Training Services</Link></li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">IT Solutions for Pharma</h2>
        <ul className="list-disc list-inside space-y-2">
          <li><Link to="/it-solutions-for-pharma/enterprise-quality-management-system-eqms">Enterprise Quality Management System (eQMS)</Link></li>
          <li><Link to="/it-solutions-for-pharma/ectd-publishing-software">eCTD Publishing Software</Link></li>
          <li><Link to="/it-solutions-for-pharma/pharmacovigilance-and-drug-safety-software">Pharmacovigilance & Drug Safety Software</Link></li>
          <li><Link to="/it-solutions-for-pharma/clinical-trial-management-platform">Clinical Trial Management Platform</Link></li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">Pharma Project Management</h2>
        <ul className="list-disc list-inside space-y-2">
          <li><Link to="/pharma-project-management/product-development-api-and-formulations">Product Development – API & Formulations</Link></li>
          <li><Link to="/pharma-project-management/analytical-development-and-microbiology-services">Analytical Development & Microbiology Services</Link></li>
          <li><Link to="/pharma-project-management/business-development-services">Business Development Services</Link></li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">Trainings</h2>
        <ul className="list-disc list-inside space-y-2">
          <li><Link to="/trainings/regulatory-training-programs">Regulatory Training Programs</Link></li>
          <li><Link to="/trainings/gmp-training-programs">GMP Training Programs</Link></li>
          <li><Link to="/trainings/corporate-training-and-professional-development">Corporate Training & Professional Development</Link></li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">Product Development & Analytical Solutions</h2>
        <ul className="list-disc list-inside space-y-2">
          <li><Link to="/product-development-and-analytical-solutions/integrated-analytical-and-product-characterization-services">Integrated Analytical and Product Characterization Services</Link></li>
          <li><Link to="/product-development-and-analytical-solutions/product-development-and-analytical-solutions">Product Development and Analytical Solutions</Link></li>
        </ul>
      </section>
    </div>
  );
};

export default PageLinks;
